import React, { Component, PureComponent } from "react";
import { Translate, withLocalize } from "react-localize-redux";
import axios from "axios";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import {
  ButtonAdd,
  ButtonCheck,
  ButtonContinue,
  ButtonDelete,
  ButtonEmptyCheck,
  DeleteHolder,
  RedFormHelperText,
} from "../general/mini_components";
import {
  Select,
  InputLabel,
  MenuItem,
  TextField,
  FormControlLabel,
  Checkbox,
  ButtonGroup,
  IconButton,
  Icon,
  Box,
  FormControl as MuiFormControl,
  Typography,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
  Grid,
  Divider,
  OutlinedInput,
  InputAdornment,
  Input,
} from "@mui/material";
import { spacing } from "@mui/system";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "date-fns";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import { Autocomplete } from "@mui/material";
import SmartField from "./SmartFields";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import File from "./File";
import { FieldWrapper } from "./mini_components";
import { Field, FieldArray } from "redux-form";
import FileBase64 from "./FileBase64";
import DrugSelector from "./SmartFields/DrugSelector";
import { formatDateByLocale } from "../../utils/index.jsx";
import { birthdateToDate } from "../../utils/birthdate";
import AppointmentField from "./SmartFields/AppointmentField";
import Multioption from "./Multioption";
import dayjs from "dayjs";
import { TimeField } from "@mui/x-date-pickers";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CloudFlare from "../general/CloudFlare/CloudFlare";
import ThumbnailViewer from "../ThumbnailViewer";
import ColoredSelectField from "./SmartFields/ColoredSelectField";
import SurgicalProcedureSelector from "./SmartFields/SurgicalProcedureSelector";
import DispositionField from "./DispositionField";
import { MedicalHistoryEditor } from "./SmartFields/Templated";
import TreatmentInpatient from "./SmartFields/TreatmentInpatient";
import ImcField from "./SmartFields/ImcField";

const FormControlSpacing = styled(MuiFormControl)(spacing);

const FormControl = styled(FormControlSpacing)`
  min-width: 148px !important;
  xmargin-top: 1rem !important;
`;
export const QuillWrapper = styled.div`
  .ql-editor {
    min-height: 200px;

    ${(props) =>
      props.error &&
      css`
        border: 1px solid red;
      `}
  }
  .ql-editor p {
    font-size: 18px;
  }
  .ql-editor ul,
  .ql-editor ol {
    font-size: 18px;
  }
`;
const EvaluateContainer = styled.div`
  display: flex;
`;
const EvaluateElement = styled.div`
  display: flex;
  flex-direction: column;
`;
const SpanElement = styled.span`
  text-align: center;
`;
const sharedStyle = css`
  // & label {
  //     position: relative;
  //     padding-right: 25px;
  //     &+div{
  //     margin-top: 0;
  //     &:before {
  //         bottom: 5px;
  //     }
  //     &:after {
  //         bottom: 5px;
  //     }
  //     svg {
  //         top: 0;
  //     }
  //     }
  // }
`;

export const TextFieldSherwood = styled(TextField)`
  ${sharedStyle}
`;

// SHER-208: compact, crash-safe formatter for the read-only display of an
// archived (soft-deleted) field's saved value. Mirrors show_records_section's
// smartfield formatting so a stored object/array never reaches a JSX text slot.
function formatArchivedItem(item) {
  if (item == null) return "";
  if (typeof item !== "object") return String(item);
  const entries = Object.entries(item).filter(
    ([k]) => k !== "postId" && k !== "treatmentPostId"
  );
  const codeEntry = entries.find(
    ([k, v]) => k.endsWith("-code") && v != null && v !== ""
  );
  const nameEntry = entries.find(
    ([k, v]) => !k.endsWith("-code") && typeof v === "string" && v.trim() !== ""
  );
  const name = nameEntry ? String(nameEntry[1]).trim() : "";
  const code = codeEntry ? String(codeEntry[1]).trim() : "";
  if (name && code) return `${name} (${code})`;
  if (name) return name;
  if (code) return code;
  try {
    return JSON.stringify(item);
  } catch (_) {
    return String(item);
  }
}

class FieldSherwood extends PureComponent {
  constructor(props) {
    super(props);
    this.typeMargin = "dense"; //dense, none;
    this.state = {
      options: [],
      date: new Date(),
      loading: false,
      showPassword: false,
      turnstileToken: "",
    };

    this.multiOptionSelected = this.multiOptionSelected.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.resetDiagnose = this.resetDiagnose.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.renderOptionText = this.renderOptionText.bind(this);
    this.imageBase64 = this.imageBase64.bind(this);
    this.handleTurnstileCallback = this.handleTurnstileCallback.bind(this);
    // cloudflare
  }

  async componentDidMount() {
    //clodflare

    if (typeof this.props.optionsUrl !== "undefined") {
      const request = await axios.get(this.props.optionsUrl);
      if (request.status === 200) {
        let options = request.data.map((opt) => {
          return { label: opt.code, value: opt.id };
        });
        this.setState({ options: options });
      }
    } else if (this.props.options) {
      this.setState({ options: this.props.options });
    }
  }

  // shouldComponentUpdate(nextProps, nextState){
  //     console.log("shouldComponentUpdate");
  //     console.log(`NextProps: ${nextProps.input.value} Props: ${this.props.input.value} Result: ${nextProps.input.value !== this.props.input.value}`);

  //     return (nextProps.input.value !== this.props.input.value);
  // }

  handleRadioChange(event) {
    const valueRetuned = event.target.value;
    const value =
      valueRetuned.toLowerCase() === "true"
        ? true
        : valueRetuned.toLowerCase() === "false"
        ? false
        : valueRetuned;

    this.props.input.onChange(value);
  }
  handleClickShowPassword = () => {
    const tempState = { ...this.state };
    this.setState({ ...tempState, showPassword: !tempState.showPassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  multiOptionSelected(value) {
    let tempValue = [{ multioption: value }];
    if (this.props.input.value !== "") {
      let index = this.props.input.value.findIndex(
        (option) => option.multioption === value
      );
      if (index !== -1) {
        tempValue = [...this.props.input.value];
        tempValue.splice(index, 1);
      } else {
        tempValue = this.props.input.value.concat(tempValue);
      }
    }
    this.props.input.onChange(tempValue);
  }
  autoCompleteChanged(value) {
    this.props.input.onChange(value);
  }
  drugSelected(drug) {
    if (import.meta.env.DEV) console.log("Treatment Drug:", drug);
    this.props.input.onChange(drug);
  }
  elementsSelected(listElements) {
    this.props.input.onChange(listElements);
  }
  resetDiagnose() {
    this.props.input.onChange(undefined);
  }
  treatmentSelected(treatments) {
    this.props.input.onChange(treatments);
  }

  handleDateChange(value) {
    // Write calendar-date strings ("YYYY-MM-DD"), not ms-since-epoch.
    //
    // Why: `.valueOf()` of a dayjs object is epoch ms of LOCAL midnight, so a
    // CEST user picking 15/04/2026 produced ms for 2026-04-14 22:00 UTC —
    // silently storing the wrong day for every European user. Postgres `date`
    // columns (e.g. insurance_claims.guarantee_letter_issue_date) also reject
    // 13-digit numbers outright → 500. Calendar strings fix both.
    //
    // The `isValid()` guard mirrors `handleTimeChange` below and prevents
    // Invalid dayjs objects (from partial typed input) from slipping through
    // as `NaN` → `null` via JSON.stringify.
    if (value !== null && typeof value.isValid === "function" && value.isValid()) {
        this.props.input.onChange(value.format("YYYY-MM-DD"));
    } else {
        this.props.input.onChange(null);
    }
  }

  handleTimeChange(value) {
    if (value !== null && value.isValid()) {
        if (import.meta.env.DEV) {
            console.log("Time to Time", value.toDate().toString());
            console.log("Time Formatted", value.format("HH:mm"));
        }
        this.props.input.onChange(value.format("HH:mm"));
    } else {
        this.props.input.onChange("");
    }
  }
  selectChange(value) {
    if (import.meta.env.DEV) console.log("Select Change", value);
    this.props.input.onChange(value);
  }
  imagesSelected(images) {
    this.props.input.onChange(images);
  }
  imageBase64(imageBase64) {
    this.props.input.onChange(imageBase64);
  }
  renderOptionText(props) {
    return (
      <FieldWrapper noWrap={this.props.fullWidth}>
        <TextFieldSherwood
          {...props.input}
          fullWidth
          variant="outlined"
          margin={this.typeMargin}
          label={props.label}
          size="small"
        />
      </FieldWrapper>
    );
  }
  renderOptions(props) {
    const { fields } = props;
    let elements = [
      <Grid item xs={12}>
        <ButtonAdd type="button" onClick={() => fields.push("")} />
      </Grid>,
    ];
    const options = fields.map((member, index) => (
      <Grid item xs={12}>
        <div style={{ display: "flex" }}>
          <Field
            name={`${member}`}
            type="text"
            component={this.renderOptionText}
            label={`Option ${index + 1}`}
          />
          <ButtonDelete onClick={() => fields.remove(index)} />
        </div>
      </Grid>
    ));
    elements = elements.concat(options);
    return <Grid container>{elements}</Grid>;
  }
  renderExtraField(extraField) {
    if (extraField) {
      if (extraField.type === "option") {
        return (
          <FieldArray
            name={`${extraField.name}_options`}
            key={extraField.name}
            component={this.renderOptions}
          />
        );
      }
    } else return null;
  }
  handleTurnstileCallback(token) {
    // Do NOT log the token — it's a short-lived auth credential for the
    // Cloudflare Turnstile exchange. Logging it to the browser console leaks
    // it into screenshots, support tickets, and any extension with console
    // access. Observed on a user-shared screenshot from chom-dakar 2026-04-22.
    this.props.input.onChange(token);
  }

  // SHER-208: read-only display of an archived (soft-deleted) field's value.
  // The redux-form Field is still registered, so its initialized value keeps
  // round-tripping through save unchanged — this only controls the UI.
  renderArchivedHtmlOrText(value) {
    if (value == null || value === "") {
      return <Typography variant="body2">-</Typography>;
    }
    const htmlFromItem = (item) =>
      item && typeof item === "object"
        ? item["template_medical_history-notes"] || item["medical_history_ai"] || null
        : null;
    if (Array.isArray(value)) {
      const html = value.map(htmlFromItem).find((h) => h);
      if (html) {
        return (
          <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
        );
      }
      const text = value.map(formatArchivedItem).filter((s) => s).join(", ");
      return <Typography variant="body2">{text || "-"}</Typography>;
    }
    if (typeof value === "object") {
      const html = htmlFromItem(value);
      if (html) {
        return (
          <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
        );
      }
      return <Typography variant="body2">{formatArchivedItem(value) || "-"}</Typography>;
    }
    if (typeof value === "string" && /<[a-z][\s\S]*>/i.test(value)) {
      return (
        <div className="ql-editor" dangerouslySetInnerHTML={{ __html: value }} />
      );
    }
    return <Typography variant="body2">{String(value)}</Typography>;
  }

  renderArchivedField(labelString) {
    return (
      <FieldWrapper noWrap={this.props.fullWidth}>
        <Box
          sx={{
            opacity: 0.75,
            borderLeft: "3px solid #bdbdbd",
            pl: 1.5,
            py: 0.5,
            my: 0.5,
          }}
        >
          <Typography
            variant="caption"
            color="textSecondary"
            component="div"
            style={{ fontWeight: 600 }}
          >
            {labelString} · <Translate id="hospital.archived-field-tag" />
          </Typography>
          {this.renderArchivedHtmlOrText(this.props.input.value)}
        </Box>
      </FieldWrapper>
    );
  }

  render() {
    const {
      input,
      color,
      label,
      meta,
      hideTitle,
      type,
      options,
      size,
      removeClass,
      template,
      defaultValue,
      disabled,
      activeLanguage,
      country,
      activationValues,
      activatedFields,
      params,
      uuidPatient,
      uuidInvestigation,
      uuidSurvey,
    } = this.props;
    const sizeCurrent = size ? size : "s12";
    const errorState = meta.touched && meta.error ? true : false;
    const errorString =
      meta.error && errorState ? this.props.translate(meta.error) : "";

    const labelString = label.hasOwnProperty("url") ? (
      <a target="_blank" without rel="noreferrer" href={label.url}>
        {this.props.translate(label.label)}
      </a>
    ) : this.props.translate(label).indexOf("Missing translationId:") !== -1 ? (
      label
    ) : (
      this.props.translate(label)
    );
    // SHER-208: an archived field's live definition (options, template, etc.)
    // no longer exists — render it read-only instead of through its type editor.
    if (this.props.archived) {
      return this.renderArchivedField(labelString);
    }
    switch (type) {
      case "select":
        let optionsArray = [];
        if (typeof this.props.optionsUrl !== "undefined") {
          optionsArray = this.state.options.map((anOption) => {
            const optionString =
              this.props
                .translate(`countries.${anOption.label}`)
                .indexOf("Missing translationId:") !== -1
                ? anOption.label
                : this.props.translate(`countries.${anOption.label}`);
            return <MenuItem value={anOption.value}>{optionString}</MenuItem>;
          });
        } else {
          optionsArray = options
            .sort((a, b) => {
              // Check if both are numbers
              const aNum = parseFloat(a.label);
              const bNum = parseFloat(b.label);
              
              if (!isNaN(aNum) && !isNaN(bNum)) {
                return aNum - bNum; // Numerical sort
              }
              
              return a.label.localeCompare(b.label); // Fallback to alphabetical
            })
            .map((option) => {
            const optionText =
              this.props
                .translate(option.label)
                .indexOf("Missing translationId:") !== -1
                ? option.label
                : this.props.translate(option.label);
            return <MenuItem value={option.value}>{optionText}</MenuItem>;
          });
        }
        
        let extraField = null;
        if (
          typeof activationValues !== "undefined" &&
          activationValues.indexOf(input.value) !== -1
        ) {
          extraField = { ...activatedFields[input.value] };
        }

        const labelId = `${input.name}_label`;
        return [
          <FieldWrapper noWrap={this.props.fullWidth}>
            <FormControl
              fullWidth
              variant="outlined"
              margin={this.typeMargin}
              error={errorState}
            >
              <InputLabel id={labelId}>{labelString}</InputLabel>
              <Select
                {...input}
                labelId={labelId}
                id={input.name}
                label={labelString}
                onChange={(event) => this.selectChange(event.target.value)}
              >
                {optionsArray}
              </Select>
            </FormControl>
          </FieldWrapper>,
          this.renderExtraField(extraField),
        ];
      // case "select":
      //     return <SelectField input={input} options={options} labelString={label} activatedFields={activatedFields}
      //         activationValues={activationValues} onChange={(value) => this.selectChange(value)}/>
      // SHER-459: operative-report "Geste principal" sources the live surgical
      // procedures catalog instead of static placeholder options.
      case "surgical_procedure":
        return (
          <FieldWrapper noWrap={this.props.fullWidth}>
            <SurgicalProcedureSelector input={input} label={labelString} error={errorState} />
          </FieldWrapper>
        );
      case "drug_selector":
        return (
          <DrugSelector
            error={errorState}
            freeSolo
            chemicalComponent={params.chemicalComponent}
            drugSelected={(drug) => this.drugSelected(drug)}
            country={country}
          />
        );
      case "appointment":
        return (
          <AppointmentField
            uuidPatient={uuidPatient}
            uuidInvestigation={uuidInvestigation}
            value={input.value}
            label={labelString}
            department={this.props.department}
            appointmentSelected={(date) => this.props.input.onChange(date)}
          />
        );
      case "multioption":
        return (
          <Multioption
            mode="input"
            color={color}
            value={input.value}
            options={options}
            label={labelString}
            name={input.name}
            multiOptionSelected={this.multiOptionSelected}
          />
        );

    case "thumbnail":
      return (
        <ThumbnailViewer imgSrc={label} />
      )
      case "radio":
        return (
          <Grid container style={{ paddingTop: "0.5rem" }}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{labelString}</FormLabel>
              <RadioGroup
                aria-label={input.name}
                name={input.name}
                value={input.value}
                onChange={this.handleRadioChange}
              >
                {options.map((option) => {
                  const labelString =
                    this.props
                      .translate(label)
                      .indexOf("Missing translationId:") !== -1
                      ? option.label
                      : this.props.translate(option.label);
                  return (
                    <FormControlLabel
                      value={option.value}
                      control={<Radio />}
                      label={labelString}
                    />
                  );
                })}
              </RadioGroup>
            </FormControl>
          </Grid>
        );

      case "checkbox":
        if (import.meta.env.DEV) console.log("Value checkbox: " + input.name + " " + input.value);
        const valueChecked = meta.touched ? input.value : defaultValue;
        const classNameError = meta.touched && meta.error ? "error text" : "";
        const className = removeClass
          ? `col ${sizeCurrent}`
          : `col ${sizeCurrent}`;
        const errorText = errorState ? (
          <RedFormHelperText>
            <Translate id="general.field-required" />
          </RedFormHelperText>
        ) : (
          ""
        );
        return [
          <FormControlLabel
            control={
              <Checkbox {...input} checked={valueChecked} disabled={disabled} />
            }
            label={labelString}
          />,
          this.props.explanation && (
            <Typography
              className={classNameError}
              variant="caption"
              component="p"
            >
              {this.props.translate(this.props.explanation)}
            </Typography>
          ),
          <FormHelperText error id="accountId-error">
            {errorString}
          </FormHelperText>,
        ];
      case "date":
        // SHER-225: encrypted personal-data DOBs may decrypt to ms-epoch digit
        // strings (legacy wire format, still emitted by the client encrypt path
        // and present in any row not touched by the SHER-196 backfill). Passing
        // those raw to dayjs() makes it parse the leading 4 digits as a year
        // ("1384819200000" → year 1384), corrupting the picker. Route through
        // birthdateToDate() so all three wire formats (ms-epoch num/string,
        // YYYY-MM-DD, Date) normalise to a real Date before dayjs sees it.
        const parsedDate = input.value ? birthdateToDate(input.value) : null;
        const value = parsedDate ? dayjs(parsedDate) : null;
        // DesktopDatePicker (not the responsive default) so the text input
        // is always editable — the default DatePicker switches to MobileDatePicker
        // when `@media (pointer: fine)` is false (touch-screen laptops, tablets)
        // and makes the input readOnly. Reported on chom-dakar 2026-04-22.
        //
        // openTo="year" so the picker opens on year-selection first — critical
        // for birthdates, where today's month is useless and clicking the back
        // arrow from 2026 to 1980 is prohibitive. Navigation is still year →
        // month → day.
        //
        // disableFuture only for birthdate / date_of_death (future values are
        // always wrong). Other date fields (appointments, scheduled treatments)
        // intentionally allow future dates, so we don't set it globally.
        const isPastOnlyField =
          input.name === "birthdate" || input.name === "date_of_death";
        return (
          <FieldWrapper
            noWrap={this.props.fullWidth}
            style={{ paddingTop: "1.5rem" }}
            data-testid={`field-${input.name}`}
          >
            <DesktopDatePicker
              value={value}
              label={labelString}
              format={formatDateByLocale(activeLanguage.code)}
              openTo="year"
              views={["year", "month", "day"]}
              disableFuture={isPastOnlyField}
              size="small"
              margin={this.typeMargin}
              slotProps={{
                textField: {
                  fullWidth: true,
                  error: errorState,
                  helperText: errorString,
                },
              }}
              onChange={this.handleDateChange}
            />
          </FieldWrapper>
        );
      case "time":
        if (import.meta.env.DEV) console.log("Time: " + input.value);
        const valueTime = input.value ? dayjs(input.value, "HH:mm") : null;
        return (
          <FieldWrapper
            noWrap={this.props.fullWidth}
            style={{ paddingTop: "1.5rem" }}
          >
            <TimeField
              value={valueTime}
              onChange={this.handleTimeChange}
              size="small"
              margin={this.typeMargin}
              label={labelString}
              slotProps={{
                textField: {
                  fullWidth: true,
                  error: errorState,
                  helperText: errorString,
                },
              }}
            />
          </FieldWrapper>
        );
      case "evaluation":
        let arrayButtons = [];
        for (let i = options[0].value; i <= options[1].value; i++) {
          let Icon = PanoramaFishEyeIcon;
          if (input.value === i) {
            Icon = FiberManualRecordIcon;
          }
          arrayButtons.push(
            <EvaluateElement>
              <Icon onClick={() => this.props.input.onChange(i)}></Icon>
              <SpanElement>
                <Typography variant="body2" gutterBottom>
                  {i}
                </Typography>
              </SpanElement>
            </EvaluateElement>
          );
        }
        return (
          <Grid container style={{ paddingTop: "0.5rem" }}>
            <Grid item xs={12}>
              <InputLabel color={color} id={input.name}>
                {labelString}
              </InputLabel>
            </Grid>
            <Grid item xs={12}>
              <EvaluateContainer>{arrayButtons}</EvaluateContainer>
            </Grid>
          </Grid>
        );

        case "hidden":
        return (
          <input
            data-testid={input.name}
            key={input.name}
            value={input.value}
            type="hidden"
            {...input}
          />
        );
        case "richtext":
            // Authoring surface (EDC template editor): same schema-based TipTap
            // editor as the fill surface, so the template is authored with the
            // toolbar + tables + PDF preview and stored as clean HTML (SHER-271).
            return (
                <Box mt={3} mb={3}>
                {!hideTitle && (
                  <Typography variant="body2" gutterBottom>
                    {labelString}:
                  </Typography>
                )}
                <MedicalHistoryEditor
                    initialValue={input.value || ""}
                    loading={false}
                    onChange={(value) => input.onChange(value)}
                />
                </Box>
            );
        case "medical_history_template":
            return (
                <Box mt={3} mb={3}>
                {!hideTitle && (
                  <Typography variant="body2" gutterBottom>
                    {labelString}:
                  </Typography>
                )}
                <MedicalHistoryEditor
                    initialValue={input.value || template}
                    loading={false}
                    onChange={(value) => input.onChange(value)}
                />
                </Box>
            );
        case "textarea":
        return (
            <Box mt={3} mb={3}>
            {!hideTitle && (
              <Typography variant="body2" gutterBottom>
                {labelString}:
              </Typography>
            )}

            <QuillWrapper className={input.name} error={errorState}>
              <ReactQuill
                style={{ fontSize: "24px" }}
                {...input}
                onChange={(newValue, delta, source) => {
                  if (source === "user") {
                    input.onChange(newValue);
                  }
                }}
                onBlur={(range, source, quill) => {
                  input.onBlur(quill.getHTML());
                }}
              />
            </QuillWrapper>
          </Box>
        );
      case "password":
        return (
          <Box mt={2}>
            <FormControl variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                {labelString}
              </InputLabel>
              <OutlinedInput
                {...input}
                color="primary"
                type={this.state.showPassword ? "text" : "password"}
                label={labelString}
                error={errorState}
                helperText={errorString}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={this.handleClickShowPassword}
                      onMouseDown={this.handleMouseDownPassword}
                    >
                      {this.state.showPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText error id="accountId-error">
                {errorString}
              </FormHelperText>
            </FormControl>
          </Box>
        );
      case "autocomplete":
        return (
          <Autocomplete
            color={color}
            id={input.name}
            options={this.state.options}
            freeSolo
            onInputChange={(event, newValue) => {
              this.autoCompleteChanged(newValue);
            }}
            getOptionLabel={(option) => option.label}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} label={labelString} variant="outlined" />
            )}
          />
        );
      case "searchable_select":
        // Sort options to ensure 100% appears last (same logic as autocomplete)
        const sortedSelectOptions = [...this.state.options].sort((a, b) => {
          // Extract percentage values from labels
          const aMatch = a.label.match(/(\d+)%/);
          const bMatch = b.label.match(/(\d+)%/);
          
          if (aMatch && bMatch) {
            const aPercent = parseInt(aMatch[1]);
            const bPercent = parseInt(bMatch[1]);
            
            // Sort numerically, but put 100% at the end
            if (aPercent === 100 && bPercent !== 100) return 1;
            if (bPercent === 100 && aPercent !== 100) return -1;
            if (aPercent === 100 && bPercent === 100) return 0;
            
            return aPercent - bPercent;
          }
          
          // Fallback to alphabetical sort for non-percentage options
          return a.label.localeCompare(b.label);
        });

        // Find the selected option based on the current value (ID)
        // Handle both string and number comparisons for robustness
        const selectedOption = sortedSelectOptions.find(option => {
          // Convert both values to strings for comparison to handle type mismatches
          return String(option.value) === String(input.value);
        }) || null;

        return (
          <FieldWrapper noWrap={this.props.fullWidth} margin={this.typeMargin} >
            <Autocomplete
              color={color}
              id={input.name}
              options={sortedSelectOptions}
              value={selectedOption}
              onChange={(event, selectedOption) => {
                // Send the ID (value) when an option is selected
                if (selectedOption && selectedOption.value !== undefined) {
                  this.props.input.onChange(selectedOption.value);
                } else {
                  // If cleared, send null
                  this.props.input.onChange(null);
                }
              }}
              // SHER-441: the coverage label keeps its percentage. It is what tells the
              // ~20 bands of one insurer apart (1.725 options in CHOM, 91 insurer names);
              // stripping it left every band reading the same. The sort below depends on
              // it too. Stripping belongs to the single-coverage displays, not here.
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => {
                // Handle comparison more robustly
                if (!option || !value) return false;
                return String(option.value) === String(value.value);
              }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label={labelString} 
                  variant="outlined"
                  margin={this.typeMargin}
                  error={errorState}
                  helperText={errorString}
                  size="small"
                  fullWidth
                />
              )}
            />
          </FieldWrapper>
        );
      case "select-autocomplete-freesolo":
        // Sort options alphabetically
        const sortedFreeSelectOptions = [...options].sort((a, b) => 
          a.label.localeCompare(b.label)
        );

        // Find the selected option or create one for freeSolo value
        // This handles both when user selects from list or types custom value
        const selectedFreeOption = sortedFreeSelectOptions.find(option => 
          String(option.value) === String(input.value)
        ) || (input.value ? { label: input.value, value: input.value } : null);

        return (
          <FieldWrapper noWrap={this.props.fullWidth} margin={this.typeMargin} >
            <Autocomplete
              color={color}
              id={input.name}
              options={sortedFreeSelectOptions}
              value={selectedFreeOption}
              freeSolo={true}
              onChange={(event, newValue) => {
                // Handle both object (from dropdown) and string (typed) values
                if (typeof newValue === 'string') {
                  // User typed a custom value
                  this.props.input.onChange(newValue);
                } else if (newValue && newValue.value !== undefined) {
                  // User selected from dropdown - use the value
                  this.props.input.onChange(newValue.value);
                } else {
                  // Cleared
                  this.props.input.onChange(null);
                }
              }}
              onInputChange={(event, newInputValue, reason) => {
                // Update the value when user types (for freeSolo)
                if (reason === 'input') {
                  this.props.input.onChange(newInputValue);
                } else if (reason === 'clear') {
                  this.props.input.onChange(null);
                }
              }}
              getOptionLabel={(option) => {
                // Handle both string and object options
                if (typeof option === 'string') return option;
                return option.label || '';
              }}
              isOptionEqualToValue={(option, value) => {
                if (!option || !value) return false;
                // Handle comparison for both string and object values
                if (typeof value === 'string') {
                  return option.value === value || option.label === value;
                }
                return String(option.value) === String(value.value);
              }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label={labelString} 
                  variant="outlined"
                  margin={this.typeMargin}
                  error={errorState}
                  helperText={errorString}
                  size="small"
                  fullWidth
                />
              )}
            />
          </FieldWrapper>
        );
      case "file":
        return (
          <File
            label={labelString}
            mode="form"
            imagesSelected={(images) => this.imagesSelected(images)}
            type={type}
            {...input}
            color={color}
            value={input.value}
          />
        );
      case "file_base64":
        return (
          <FileBase64
            color={color}
            label={labelString}
            error={errorState}
            value={input.value}
            callBackBase64={this.imageBase64}
          />
        );
      // SHER-629: this block, and the two other `formValues={this.props.formValues}`
      // sites further down, are the ONLY places that read the whole-form snapshot.
      // form.jsx passes it to those types only, driven by FIELD_TYPES_USING_FORM_VALUES
      // in src/constants. Adding a case here that forwards formValues WITHOUT adding it
      // to that list makes the prop arrive as undefined (MedicalHistoryAI would throw on
      // Object.values). FieldSherwood.test.tsx asserts the two stay in step.
      case "edd":
      case "bmi":
      case "allergy":
      case "family-background":
      case "background":
      // SHER-172: DB stores diagnosis fields as type='icd' after FixIcdFieldTypes migration.
      // We accept the legacy aliases too so any pre-migration ('ict') or partially-migrated ('icd11')
      // rows still render until they're cleaned up by a one-off backfill.
      case "icd":
      case "icd11":
      case "ict":
      case "treatment":
      case "treatment_prescription":
      case "treatment_regular":
        return (
          <SmartField
            mode="form"
            formValues={this.props.formValues}
            label={labelString}
            type={type}
            {...input}
            initialState={
              Array.isArray(input.value) ? { listElements: input.value } : null
            }
            variant="outlined"
            margin={this.typeMargin}
            error={errorState}
            country={country}
            template={template}
            uuidPatient={uuidPatient}
            uuidInvestigation={uuidInvestigation}
            uuidSurvey={uuidSurvey}
            color={color}
            helperText={errorString}
            resetDiagnose={this.resetDiagnose}
            typeMargin={this.typeMargin}
            size="small"
            slaves={this.props.slaves}
            elementSelected={(listDiagnoses) =>
              this.elementsSelected(listDiagnoses)
            }
            onTreatmentAdded={this.props.onTreatmentAdded}
            fieldInfo={this.props.fieldInfo}
            idSubmission={this.props.idSubmission}
            onSaveToDatabase={this.props.onSaveToDatabase}
            onUpdateDatabase={this.props.onUpdateDatabase}
            onDeleteDatabase={this.props.onDeleteDatabase}
            allergyState={this.props.allergyState}
            onUpdateAllergies={this.props.onUpdateAllergies}
          />
        );
      case "treatment_inpatient":
        return (
          <TreatmentInpatient
            mode="form"
            variant="outlined"
            language={this.props.activeLanguage?.code || 'en'}
            typeMargin={this.typeMargin}
            type={type}
            uuidPatient={uuidPatient}
            uuidInvestigation={uuidInvestigation}
            slaves={this.props.slaves}
            country={country}
            template={template}
            elementSelected={(listElements) => this.elementsSelected(listElements)}
            error={errorState}
            initialTreatments={Array.isArray(input.value) ? input.value : []}
          fieldInfo={this.props.fieldInfo}
          uuidSurvey={this.props.uuidSurvey}
          idSubmission={this.props.idSubmission}
          onSaveToDatabase={this.props.onSaveToDatabase}
          onUpdateDatabase={this.props.onUpdateDatabase}
          onDeleteDatabase={this.props.onDeleteDatabase}
          />
        );
      case "request_lab":
      case "request_img":
      case "medical_history_ai":
      case "medical_history_template_fill":
      case "template_medical_history":
        return (
          <SmartField
            mode="form"
            formValues={this.props.formValues}
            label={labelString}
            type={type}
            {...input}
            initialState={
              Array.isArray(input.value) ? { listElements: input.value } : null
            }
            variant="outlined"
            margin={this.typeMargin}
            error={errorState}
            country={country}
            template={template}
            uuidPatient={uuidPatient}
            uuidInvestigation={uuidInvestigation}
            uuidSurvey={uuidSurvey}
            color={color}
            helperText={errorString}
            resetDiagnose={this.resetDiagnose}
            typeMargin={this.typeMargin}
            size="small"
            slaves={this.props.slaves}
            elementSelected={(listDiagnoses) =>
              this.elementsSelected(listDiagnoses)
            }
            onTreatmentAdded={this.props.onTreatmentAdded}
          />
        );
      case "imc":
        // SHER-210: auto-calculated, read-only BMI derived from the sibling
        // weight/height fields on the form (matched by name convention).
        return (
          <ImcField
            formValues={this.props.formValues}
            input={input}
            label={labelString}
            fullWidth={this.props.fullWidth}
          />
        );
      case "title_section":
        return (
          <Typography
            variant="subtitle1"
            color="textPrimary"
            style={{ fontWeight: 600 }}
          >
            {labelString}
          </Typography>
        );
        case "text_blob":
        return (
          <Typography variant="body2" color="textPrimary">
            {labelString} 
          </Typography>
        );
      case "separator":
        return <Divider />;
      case "cloudflare":
        return (
          <FieldWrapper
            noWrap={this.props.fullWidth}
            style={{ paddingTop: "1rem" }}
          >
            <CloudFlare
              class="cf-turnstile"
              data-sitekey={import.meta.env.VITE_APP_SITE_KEY_CLOUDFLARE}
              callback={this.handleTurnstileCallback}
              error={errorState}
            />
          </FieldWrapper>
        );
        case "label_value":
          return (
            <Typography variant="body2" color="textPrimary">
              {labelString}: {this.props.input.value}
            </Typography>
          );
        case "disposition":
            return (
              <DispositionField
                input={this.props.input}
                meta={this.props.meta}
                label={labelString}
                disabled={this.props.disabled}
                translate={this.props.translate}
              />
            );
        case "select-coloured":
            return (
              <ColoredSelectField
                {...input}
                translate={this.props.translate}
                input={this.props.input}
                meta={this.props.meta}
                label={labelString}
                options={options}
                disabled={this.props.disabled}
              />
            );
      default:
        return (
          <FieldWrapper noWrap={this.props.fullWidth}>
            <TextFieldSherwood
              {...input}
              fullWidth
              variant="outlined"
              margin={this.typeMargin}
              label={labelString}
              error={errorState}
              size="small"
              color={color}
              helperText={errorString}
            />
          </FieldWrapper>
        );
    }
  }
}

FieldSherwood.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  defaultOption: PropTypes.object,
  size: PropTypes.string,
  option: PropTypes.object,
  removeClass: PropTypes.string,
};
export default withLocalize(FieldSherwood);
